import Layout from "../../layout/default";
import Maintenance from "../../component/Maintenance";

const MaintenancePage = () => {
  return (
    <Layout>
      <Maintenance />
    </Layout>
  );
};

export default MaintenancePage;
